export default "__VITE_ASSET__Cls81qFd__"